import React from 'react';
import IFrameToy from "../components/iFrameToy";

export default function FlappyToy(props) {
  return (
    <IFrameToy url={'/toys/flappy'} {...props} />
  )
}